/**
 * Enum para los diferentes estados de "Ya tenemos tus datos"
 * Cada estado tiene un código numérico asociado
 */
export enum YaTenemosEstado {
  /** Ya tenemos tus datos - Lead abandono página de planes */
  LEAD_ABANDONO_PAGINA_PLANES = 66,
  
  /** Ya tenemos tus datos - Lead abandono resumen */
  LEAD_ABANDONO_RESUMEN = 68,
  
  /** Ya tenemos tus datos - Datos Errados Runt */
  DATOS_ERRADOS_RUNT = 79, 




   /** Cotización en Pausa - Lead Falla Run */
  LEAD_FALLA_RUN = 70,
  
  /** Cotización en Pausa - Lead falla servicio Fasecolda */
  LEAD_FALLA_SERVICIO_FASECOLDA = 71,
  
  /** Cotización en Pausa - Lead propietario persona jurídica */
  LEAD_PROPIETARIO_PERSONA_JURIDICA = 54,
  
  /** Cotización en Pausa - Lead uso Comercial */
  LEAD_USO_COMERCIAL = 53,
  
  /** Cotización en Pausa Política antihurto */
  POLITICA_ANTIHURTO = 77,
  
  /** Cotización en Pausa Lead prenda_si */
  LEAD_PRENDA_SI = 63,
  
  /** Cotización en Pausa Lead máximo prima */
  LEAD_MAXIMO_PRIMA = 60,
  
  VALIDACION_SALVAMENTO=80,
  /** Cotización en Pausa Falla Técnica Cotizador */
  FALLA_TECNICA_COTIZADOR = 100,

  VALIDACION_MOVILIDAD_FALLIDA = 56,
  VALIDACION_COMBUSTIBLE_FALLIDA= 49

}

/**
 * Mapeo de códigos a descripciones legibles
 */
export const YaTenemosDescripciones: Record<YaTenemosEstado, string> = {
  [YaTenemosEstado.LEAD_ABANDONO_PAGINA_PLANES]: 'Ya tenemos tus datos - Lead abandono página de planes',
  [YaTenemosEstado.LEAD_ABANDONO_RESUMEN]: 'Ya tenemos tus datos - Lead abandono resumen',
  [YaTenemosEstado.DATOS_ERRADOS_RUNT]: 'Ya tenemos tus datos - Datos Errados Runt',


    // agregando nuevos estados
   [YaTenemosEstado.LEAD_FALLA_RUN]: 'Ya tenemos tus datos - Lead Falla Run',
  [YaTenemosEstado.LEAD_FALLA_SERVICIO_FASECOLDA]: 'Ya tenemos tus datos - Lead falla servicio Fasecolda',
  [YaTenemosEstado.LEAD_PROPIETARIO_PERSONA_JURIDICA]: 'Ya tenemos tus datos - Lead propietario persona jurídica',
   [YaTenemosEstado.LEAD_USO_COMERCIAL]: 'Ya tenemos tus datos - Lead uso Comercial',
  [YaTenemosEstado.POLITICA_ANTIHURTO]: 'Ya tenemos tus datos - Pausa Política antihurto',
  [YaTenemosEstado.LEAD_PRENDA_SI]: 'Ya tenemos tus datos - Lead prenda_si',
    [YaTenemosEstado.LEAD_MAXIMO_PRIMA]: 'Ya tenemos tus datos - Lead máximo prima',
  [YaTenemosEstado.FALLA_TECNICA_COTIZADOR]: 'Ya tenemos tus datos - Falla Técnica Cotizador',
  [YaTenemosEstado.VALIDACION_MOVILIDAD_FALLIDA]: 'Ya tenemos tus datos - Políticas de Negocio Fallidas',

  [YaTenemosEstado.VALIDACION_COMBUSTIBLE_FALLIDA]:'Ya tenemos tus datos - No pasa validación de tipo de combustible',
  [YaTenemosEstado.VALIDACION_SALVAMENTO]: 'Ya tenemos tus datos - No pasa validacion de siniestro',

};
